// extracted by mini-css-extract-plugin
export var progressBar = "_np-0";
export var progressBarInner = "_np-1";